import styled from 'styled-components/macro'

export const TextAreaSC = styled.textarea`
  grid-area: txtarea;
  background-color: rgba(51, 61, 108, 0.06);
  outline: none;
  border: 2px solid rgba(51, 61, 108, 0.08);
  padding: 17px 20px;
  border-radius: 8px;
  resize: none;
  margin-bottom: 20px;
  font-family: Mulish, sans-serif;

  &::placeholder {
    color: #8E93AF;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
  }
`
